import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import 'moment';
import 'bootstrap-css';
import 'font-awesome/css/font-awesome.css';
import './styles/index.css';
import App from './components/App';
import jsonData from './resume.json';

ReactDOM.render(
  <CookiesProvider><App source={jsonData}/></CookiesProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js